import script from "./CarouselComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CarouselComponent.vue?vue&type=style&index=0&id=249d115c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-249d115c"]])

export default __exports__